import {defineCssVars, defineStyleConfig} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';

import {components} from '../../../design-tokens/dark';
import {components as dark} from '../../../design-tokens/light';

export const {color: $color} = defineCssVars(`paginationTrigger`, [`color`]);

export const triggerCssVars = {
  [$color.variable]: mode(
    components.colors.components.toggles[`icon-default`],
    dark.colors.components.toggles[`icon-default`],
  ),
};

export const triggerStyle = defineStyleConfig({
  baseStyle: {
    // color: $color.reference,
  },
  defaultProps: {},
  // TODO This should work but it doesn't...
  variants: {
    next: {
      borderRightRadius: 0,
    },
    prev: {
      borderLeftRadius: 0,
    },
  },
});
